import React from 'react';
import { createRoot } from 'react-dom/client';
import { Workbox } from 'workbox-window';
import * as Sentry from '@sentry/react';
import 'reflect-metadata';

import './styles/default.scss';
import App from './App';
import { initWebVitals } from './reportWebVitals';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RecoilRoot } from 'recoil';
import { I18nextProvider } from 'react-i18next';
// TODO: fix this import
// eslint-disable-next-line @nx/enforce-module-boundaries
import version from '../../../version';
import i18n from './services/i18n/i18n.service';
import { ErrorBoundary } from '@jaam/web-core';

// eslint-disable-next-line max-len
const isProd = process.env.NX_ENV === 'production';

Sentry.init({
  dsn: process.env.NX_REACT_PAYROLLR_SENTRY_DSN,
  replaysSessionSampleRate: isProd ? 0.02 : 1.0,
  replaysOnErrorSampleRate: 1.0,
  enableTracing: true,
  integrations: [
    new Sentry.BrowserTracing(),
    new Sentry.Replay(),
    ...(isProd ? [] : [new Sentry.BrowserProfilingIntegration()]),
  ],
  environment: process.env.NX_ENV,
  tracesSampleRate: isProd ? 0.1 : 1.0,
  release: 'jaam@' + version,
});
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      gcTime: 1000 * 60 * 10,
      refetchOnWindowFocus: false,
    },
  },
});
const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
initWebVitals();
root.render(
  <I18nextProvider i18n={i18n}>
    <RecoilRoot>
      <QueryClientProvider client={queryClient}>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </QueryClientProvider>
    </RecoilRoot>
  </I18nextProvider>,
);

// sw.js is only emitted by the production build; skip registration in dev.
if (isProd && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    new Workbox('/sw.js').register();
  });
}
